import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { ProductMovement } from './product-movement'

export class ProductMovementsRepository extends BaseRepository<ProductMovement> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/product-movements', token, cache)
    }
}
